import styled from "styled-components";
import { Button } from "../../AppStyle";

export const HeroSection = styled.section`
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.background};
  box-shadow: inset 0 0 0 1000px rgba (0, 0, 0, 0.2);
  transition: background-color 0.3s ease-in;

  @media screen and (max-width: 1200px) {
    width: 100%;
    padding-top: 50px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  .NoPasswordImage {
    margin: 40px 0;
    max-width: 1100px;
    width: 115%;
    height: auto;
    object-fit: contain;
    align-self: center;
    transition: background-color 0.3s ease-in;
  }
`;

export const HeroButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 35px;
  color: black;
  border: 0px;
  border-radius: 15px;
  background: #dddf21;
  font-size: 15px;
  margin: 20px auto 20px;
  font-weight: 550;

  &:before {
    height: 500%;
  }

  &:hover:before {
    height: 0%;
  }

  &:hover {
    color: black;
    background-color: rgba(220, 223, 33, 0.85);
    transition-duration: 0.1s;
  }

  &:active {
    background-color: rgba(159, 159, 25, 0.83);
    color: black;
    transition-duration: 0.1s;
  }

  @media screen and (max-width: 1200px) {
    font-size: 17px;
    width: 100%;
    max-width: 400px;
    height: 3rem;
    margin: 20px auto 30px;
    border-radius: 30px;
  }
`;

export const HomeInfo = styled.div`
  padding: 40px 50px;

  .MainRow {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 40px;
    flex-wrap: wrap;
  }

  .LeftContent {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 300px;
  }

  .RightImage {
    max-width: 550px;
    width: 100%;
    height: auto;
    align-self: flex-start;
    margin-right: 0;
  }

  .TitleHome {
    font-size: 40px;
    color: ${({ theme }) => theme.text};
    font-family: "Roboto", "Montserrat", "Instruments-sans", sans-serif;
    margin-bottom: 20px;
    width: 100%;
    max-width: 600px;

    .DescriptionSubtext {
      color: ${({ theme }) => theme.subtext};
      font-weight: 700;
    }
  }

  @media screen and (max-width: 1024px) {
    padding: 40px 30px;

    .MainRow {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .leftContent {
      order: 2;
      display: flex;
      flex-direction: column;
      width: 100%;
      padding: 0;
    }

    .TitleHome {
      font-size: 28px;
      max-width: 350px;
      text-align: flex-start;
    }

    .RightImage {
      order: -1;
      width: 80%;
      max-width: 400px;
      margin: 20px 0;
      align-self: center;
    }
  }
`;

export const CardHome = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 5rem auto 5rem auto;
  transition: background-color 0.3s ease-in;

  .TitleHome {
    font-size: 30px;
    font-weight: 600;
    color: ${({ theme }) => theme.text};
    margin-bottom: 10px;
    font-family: "Roboto", "Montserrat", "Instruments-sans", sans-serif;
    transition: background-color 0.3s ease-in;

    text-align: center;
  }

  @media screen and (max-width: 1024px) {
    .TitleHome {
      font-size: 30px;
      max-width: 350px;
      margin-bottom: 10px;
    }
  }
`;

export const HeroText = styled.div`
  background: white;
  width: 40%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

export const ItemWrapper = styled.div`
  margin-top: 20px;
  height: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 1200px) {
    width: 100%;
    padding: 10px 0px 0px 0px;
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 1.5rem;
    padding: 0 20px;
  }

  @media (max-widh: 600px) {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 0 15px;
  }
`;

export const ServicesWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-top: 30px;
  padding-bottom: 100px;
  background-color: ${({ theme }) => theme.section};
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  overflow: hidden;
  transition: background-color 0.3s ease-in;

  .ServicesInner {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 70px 20px;
  }
  .ServicesTitle {
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 40px;
    color: ${({ theme }) => theme.text};
    transition: background-color 0.3s ease-in;
  }
  .ServicesCards {
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: row;
    gap: 40px;
    flex-wrap: wrap;
  }
  .ServiceCard {
    flex: 1 1 300px;
    max-width: 500px;
    border-radius: 12px;
    padding: 20px;
    color: ${({ theme }) => theme.text};
    display: flex;
    flex-direction: column;
    gap: 15px;
    transition: background-color 0.3s ease-in;
  }
  .ServiceCard img {
    background-color: ${({ theme }) => theme.vault};
    color: ${({ theme }) => theme.text};
    border-radius: 50%;
    padding: 10px;
    width: 40px;
    object-fit: contain;
    transition: background-color 0.3s ease-in;
  }

  @media screen and (max-width: 768px) {
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 120px;
      background: linear-gradient(
        to bottom,
        ${({ theme }) => theme.background},
        rgba(255, 255, 255, 0)
      );
      z-index: 1;
      transition: opacity 0.3s ease-in;
    }

    .ServicesInner:nth-of-type(1) .ServicesTitle {
      visibility: hidden;
      height: 40px;
      margin-bottom: 40px;
    }
    .ServicesInner:nth-of-type(2) .ServicesTitle {
      display: block;
    }
    .ServicesInner {
      display: flex;
      position: relative;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 30px 20px;
    }
    .ServicesCards {
      flex-direction: column;
      gap: 5px;
    }
    .ServicesTitle {
      font-size: 24px;
    }
    .ServiceSubtitle {
      font-size: 20px;
    }
    .ServiceDescription {
      font-size: 14px;
    }
    .ServiceCard img {
      background-color: ${({ theme }) => theme.vault};
      color: ${({ theme }) => theme.text};
      border-radius: 50%;
      padding: 10px;
      height: 50px;
      width: 50px;
      object-fit: contain;
      transition: background-color 0.3s ease-in;
    }
  }
`;
